//以“key”为名称存储一个值“value”
let setStorage = function (key, value) {
    return sessionStorage.setItem(key, JSON.stringify(value));
}
//获取名称为“key”的值
let getStorage = function (key) {
    return JSON.parse(sessionStorage.getItem(key))
}

let removeItemStorage = function (key) {
    return sessionStorage.removeItem(key)
}
let clearStorage = function (key) {
    return sessionStorage.clear();
}
export default { setStorage, getStorage, removeItemStorage, clearStorage }


// WEBPACK FOOTER //
// ./src/utils/session.js